<template>
  <div v-if="bar" class="c4-bar" :aria-label="tx('id.label')">
    <button
      type="button"
      class="c4-camb"
      data-fk="camb"
      :disabled="!ready"
      :aria-label="tx('id.camera')"
      @click="$emit('open-camera')"
    >
      <i class="mdi mdi-qrcode-scan" aria-hidden="true"></i>
    </button>
    <label class="c4-idf" :class="{ bad: !!bad }">
      <input
        ref="input"
        data-fk="id"
        type="text"
        inputmode="numeric"
        autocomplete="off"
        :placeholder="tx('id.ph')"
        :value="value"
        :aria-label="tx('id.label')"
        @input="onInput"
        @keyup.enter="$emit('enter')"
      />
      <button v-if="value" type="button" class="c4-idx" data-fk="clr" :aria-label="tx('id.clear')" @click="$emit('clear')">
        <i class="mdi mdi-close" aria-hidden="true"></i>
      </button>
    </label>
    <button type="button" class="c4-go" data-fk="go" :disabled="!value || !ready" :aria-label="tx('id.submit')" @click="$emit('submit')">
      <i class="mdi mdi-arrow-right" aria-hidden="true"></i>
    </button>
    <div class="c4-idm" :class="{ bad: !!bad }" role="alert">{{ message }}</div>
  </div>

  <section v-else class="c4-idc">
    <div class="c4-idl">
      {{ tx("id.label") }} <span>{{ tx("id.hint") }}</span>
    </div>
    <div class="c4-idr">
      <label class="c4-idf" :class="{ bad: !!bad }">
        <input
          ref="input"
          data-fk="id"
          type="text"
          inputmode="numeric"
          autocomplete="off"
          :placeholder="tx('id.ph')"
          :value="value"
          :aria-label="tx('id.label')"
          @input="onInput"
          @keyup.enter="$emit('enter')"
        />
        <button v-if="value" type="button" class="c4-idx" data-fk="clr" :aria-label="tx('id.clear')" @click="$emit('clear')">
          <i class="mdi mdi-close" aria-hidden="true"></i>
        </button>
      </label>
      <button type="button" class="c4-go" data-fk="go" :disabled="!value || !ready" :aria-label="tx('id.submit')" @click="$emit('submit')">
        <i class="mdi mdi-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="c4-idb">
      <button v-if="!readerOnly" type="button" class="c4-link" data-fk="pad" @click="$emit('toggle-pad')">
        <i class="mdi" :class="pad ? 'mdi-camera-outline' : 'mdi-dialpad'" aria-hidden="true"></i>
        {{ pad ? tx("id.camera") : tx("id.keypad") }}
      </button>
    </div>
    <div class="c4-idm" :class="{ bad: !!bad }" role="alert">{{ message }}</div>
  </section>
</template>

<script>
import canteenV4Text from "@/mixins/canteenV4Text";

export default {
  name: "CanteenIdField",
  mixins: [canteenV4Text],
  props: {
    value: { type: String, default: "" },
    ready: { type: Boolean, default: true },
    // poruka o neispravnom unosu
    bad: { type: String, default: "" },
    // telefon: donja traka (dugme kamere, polje, strelica)
    bar: { type: Boolean, default: false },
    pad: { type: Boolean, default: false },
    readerOnly: { type: Boolean, default: false },
  },
  computed: {
    message() {
      if (this.bad) return this.bad;
      if (!this.ready && this.value) return this.tx("id.wait");
      return this.bar || this.readerOnly ? "" : this.tx("id.help");
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value.replace(/\s/g, ""));
    },
    focus(end) {
      const el = this.$refs.input;
      if (!el) return;
      el.focus();
      if (end) el.setSelectionRange(el.value.length, el.value.length);
    },
  },
};
</script>
